// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    ArrowRightLeft,
    ArrowRightToLine,
    ArrowUp,
    ArrowUp01,
    ArrowUp10,
    ArrowUpAZ,
    ArrowUpDown,
    ArrowUpFromDot,
    ArrowUpFromLine,
    ArrowUpLeft,
    ArrowUpNarrowWide,
    ArrowUpRight,
    ArrowUpToLine,
    ArrowUpWideNarrow,
    ArrowUpZA,
    ArrowsUpFromLine,
    Asterisk,
    Astroid,
    AtSign,
    Atom,
    AudioLines,
    AudioLinesOff,
    AudioLinesX,
    AudioWaveform,
    Award,
    Axe,
    Axis3d,
    Baby,
    Backpack,
    Badge,
    BadgeAlert,
    BadgeCent,
    BadgeCheck,
    BadgeDollarSign,
    BadgeEuro,
    BadgeIndianRupee,
    BadgeInfo,
    BadgeJapaneseYen,
    BadgeMinus,
    BadgePercent,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "arrow-right-left" through "badge-percent", inclusive. */
const shard: Record<string, LucideIcon> = {
    "arrow-right-left": ArrowRightLeft,
    "arrow-right-to-line": ArrowRightToLine,
    "arrow-up": ArrowUp,
    "arrow-up-0-1": ArrowUp01,
    "arrow-up-1-0": ArrowUp10,
    "arrow-up-a-z": ArrowUpAZ,
    "arrow-up-down": ArrowUpDown,
    "arrow-up-from-dot": ArrowUpFromDot,
    "arrow-up-from-line": ArrowUpFromLine,
    "arrow-up-left": ArrowUpLeft,
    "arrow-up-narrow-wide": ArrowUpNarrowWide,
    "arrow-up-right": ArrowUpRight,
    "arrow-up-to-line": ArrowUpToLine,
    "arrow-up-wide-narrow": ArrowUpWideNarrow,
    "arrow-up-z-a": ArrowUpZA,
    "arrows-up-from-line": ArrowsUpFromLine,
    asterisk: Asterisk,
    astroid: Astroid,
    "at-sign": AtSign,
    atom: Atom,
    "audio-lines": AudioLines,
    "audio-lines-off": AudioLinesOff,
    "audio-lines-x": AudioLinesX,
    "audio-waveform": AudioWaveform,
    award: Award,
    axe: Axe,
    "axis-3d": Axis3d,
    baby: Baby,
    backpack: Backpack,
    badge: Badge,
    "badge-alert": BadgeAlert,
    "badge-cent": BadgeCent,
    "badge-check": BadgeCheck,
    "badge-dollar-sign": BadgeDollarSign,
    "badge-euro": BadgeEuro,
    "badge-indian-rupee": BadgeIndianRupee,
    "badge-info": BadgeInfo,
    "badge-japanese-yen": BadgeJapaneseYen,
    "badge-minus": BadgeMinus,
    "badge-percent": BadgePercent,
};

export default shard;
